import { RootState } from '../reducers';

/**
 * Gets number of unread messages + unread invites in the state.
 *
 * @param state
 * @returns
 */
export const getUnreadCount = (state: RootState): number => state?.inquiry?.unreadCount;

/**
 * Gets if the account has sent a first inquiry.
 *
 * @param state
 * @returns
 */
export const getHasInquiries = (state: RootState): boolean => state?.inquiry?.hasInquiries;
